import React, {Component} from 'react';
import {Form, Control, Fieldset} from "react-redux-form";
import {formatMoney} from "accounting-js";
import moment from "moment/moment";
import _ from 'lodash';
import EditStatus from "../forms/edit_status";
import NotificationStatus from "../forms/notification_status";

export const onlyUnique = (value, index, self) => {
	return self.indexOf(value) === index;
}

export const get_municipios_list_text = (project_goal_activities) => {
	let mun_array = [];
	if(project_goal_activities){
		for(let i=0; i < project_goal_activities.length ;i++){
			if(project_goal_activities[i]['persons'] && project_goal_activities[i]['persons'] !== null && project_goal_activities[i]['persons'] !== undefined && project_goal_activities[i]['persons'].length > 0){
				for(let j=0; j < project_goal_activities[i]['persons'].length ;j++){
					let key = "municipalities";
					if (project_goal_activities[i]['persons'][j][key] && project_goal_activities[i]['persons'][j][key] !== undefined) {
						for(let z=0; z < project_goal_activities[i]['persons'][j][key].length ;z++){
							if(project_goal_activities[i]['persons'][j][key][z] && project_goal_activities[i]['persons'][j][key][z]["name"] !== undefined){
								mun_array.push(project_goal_activities[i]['persons'][j][key][z]["name"]);
							}
						}
					}
				}
			}
		}
		if(mun_array.length > 0){
			let unique = mun_array.filter(onlyUnique);
			return unique.sort().join(", ");
		}
	}
	return "-";
}

export const sum_personas_atendidas = (project_goal_activities) => {
	const persons_total = {
		"count_person_f_1_1": 0,
		"count_person_f_1_2": 0,
		"count_person_f_1_3": 0,
		"count_person_f_1_4": 0,
		"count_person_f_1_5": 0,
		"count_person_m_1_1": 0,
		"count_person_m_1_2": 0,
		"count_person_m_1_3": 0,
		"count_person_m_1_4": 0,
		"count_person_m_1_5": 0,
		"count_person_o_1_1": 0,
		"count_person_o_1_2": 0,
		"count_person_o_1_3": 0,
		"count_person_o_1_4": 0,
		"count_person_o_1_5": 0,
		"count_person_f_2_1": 0,
		"count_person_f_2_2": 0,
		"count_person_f_2_3": 0,
		"count_person_f_2_4": 0,
		"count_person_f_2_5": 0,
		"count_person_m_2_1": 0,
		"count_person_m_2_2": 0,
		"count_person_m_2_3": 0,
		"count_person_m_2_4": 0,
		"count_person_m_2_5": 0,
		"count_person_o_2_1": 0,
		"count_person_o_2_2": 0,
		"count_person_o_2_3": 0,
		"count_person_o_2_4": 0,
		"count_person_o_2_5": 0,
		"count_person_f_3_1": 0,
		"count_person_f_3_2": 0,
		"count_person_f_3_3": 0,
		"count_person_f_3_4": 0,
		"count_person_f_3_5": 0,
		"count_person_m_3_1": 0,
		"count_person_m_3_2": 0,
		"count_person_m_3_3": 0,
		"count_person_m_3_4": 0,
		"count_person_m_3_5": 0,
		"count_person_o_3_1": 0,
		"count_person_o_3_2": 0,
		"count_person_o_3_3": 0,
		"count_person_o_3_4": 0,
		"count_person_o_3_5": 0,
		"count_person_f_4_1": 0,
		"count_person_f_4_2": 0,
		"count_person_f_4_3": 0,
		"count_person_f_4_4": 0,
		"count_person_f_4_5": 0,
		"count_person_m_4_1": 0,
		"count_person_m_4_2": 0,
		"count_person_m_4_3": 0,
		"count_person_m_4_4": 0,
		"count_person_m_4_5": 0,
		"count_person_o_4_1": 0,
		"count_person_o_4_2": 0,
		"count_person_o_4_3": 0,
		"count_person_o_4_4": 0,
		"count_person_o_4_5": 0,
		"count_person_f_5_1": 0,
		"count_person_f_5_2": 0,
		"count_person_f_5_3": 0,
		"count_person_f_5_4": 0,
		"count_person_f_5_5": 0,
		"count_person_m_5_1": 0,
		"count_person_m_5_2": 0,
		"count_person_m_5_3": 0,
		"count_person_m_5_4": 0,
		"count_person_m_5_5": 0,
		"count_person_o_5_1": 0,
		"count_person_o_5_2": 0,
		"count_person_o_5_3": 0,
		"count_person_o_5_4": 0,
		"count_person_o_5_5": 0
	};
	let total_count_person = 0;
	if(project_goal_activities){
		for(let i=0; i < project_goal_activities.length ;i++){
			if(project_goal_activities[i]['persons'] && project_goal_activities[i]['persons'] !== null && project_goal_activities[i]['persons'] !== undefined && project_goal_activities[i]['persons'].length > 0){
				for(let j=0; j < project_goal_activities[i]['persons'].length ;j++){
					for(let key of Object.keys(persons_total)){
						if (project_goal_activities[i]['persons'][j][key] && project_goal_activities[i]['persons'][j][key] !== undefined) {
							persons_total[key] += parseInt(project_goal_activities[i]['persons'][j][key]);
							total_count_person += parseInt(project_goal_activities[i]['persons'][j][key])
						}
					}
				}
			}
		}
	}
	return total_count_person;
};

export default class ReportsFinancialEditForm extends Component{
	render(){
		const { reports, revision } = this.props;
		const { modality } = this.props.match.params;
		const { financial, summary } = reports;
		const styleActions = {
			position: 'relative',
			display: 'inline',
			top: '1.7em',
			left: '-29px',
			width: '30px',
		}
		const styleActionsActivity = {
			position: 'relative',
			display: 'inline',
			width: '30px',
		}
		let rc = _.find(revision.permissions, (o) => {return o==='Create'}) ? true:false;

		return(
			<div className="columns is-centered">
				<div className="column is-11">
					<Form model="revision" onSubmit={(values) => this._submitForm(values)}>
						<h1 className="title is-6">DATOS DEL PROYECTO</h1>
						{/* here */}
						<table className="table is-fullwidth project-goal-table no-margin">
							<tbody>
							<tr>
								<td colSpan={2} style={{width: '50%'}}>
									<span className="help is-dark">Titular</span>
									<strong>{!_.isEmpty(summary.data) ? `${summary.data.agency.owner.name} ${summary.data.agency.owner.last_name} ${summary.data.agency.owner.slast_name}`:'---'}</strong>
								</td>
								<td colSpan={modality === 'modalidad-ii' ? 1:2} style={{width: modality === 'modalidad-ii' ? '25%':'50%'}}>
									<span className="help is-dark">Entidad</span>
									{modality==='modalidad-ii' ?
										<strong>{this._stateName()}</strong>
										:<strong>{!_.isEmpty(summary.data) && summary.data.agency.agenciable ? summary.data.agency.agenciable.name : '---'}</strong>}
								</td>
								{modality === 'modalidad-ii' ?
								<td colSpan={1} style={{width: '25%'}}>
									<span className="help is-dark">Municipio</span>
									<strong>{!_.isEmpty(summary.data) && summary.data.agency.agenciable ? summary.data.agency.agenciable.name : '---'}</strong>
								</td>
								:null}
							</tr>
							<tr>
								<td colSpan={4}>
									<span className="help is-dark">Instancia</span>
									<strong>{!_.isEmpty(summary.data) && summary.data.agency.name ? summary.data.agency.name : '---'}</strong>
								</td>
							</tr>
							<tr>
								<td colSpan={4}>
									<span className="help is-dark">Proyecto</span>
									<strong>{!_.isEmpty(summary.data) && summary.data.name ? summary.data.name : '---'}</strong>
								</td>
							</tr>
							<tr>
								<td style={{width: '25%'}}>
									<div className="columns">
										<div className="column is-1">
											<i className="fa fa-usd fa-2x" />
										</div>
										<div className="column">
											<span className="help is-dark">Monto aprobado</span>
											<strong> {summary.data.amounts && summary.data.amounts.goals ? `${formatMoney(summary.data.amounts.goals.total)}` : '---'}</strong>
										</div>
									</div>
								</td>
								<td style={{width: '25%'}}>
									<div className="columns">
										<div className="column is-1">
											<i className="fa fa-usd fa-2x" />
										</div>
										<div className="column">
											<span className="help is-dark">Monto ejercido</span>
											<strong> {summary.data.amounts && summary.data.amounts.goals ? `${formatMoney(summary.data.amounts.goals.spent)}` : '---'}</strong>
										</div>
									</div>
								</td>
								<td style={{width: '25%'}}>
									<div className="columns">
										<div className="column is-1">
											<i className="fa fa-usd fa-2x" />
										</div>
										<div className="column">
											<span className="help is-dark">Monto por ejercer</span>
											<strong> {summary.data.amounts && summary.data.amounts.goals ? `${formatMoney(summary.data.amounts.goals.missing)}` : '---'}</strong>
										</div>
									</div>
								</td>
								<td style={{width: '25%'}}>
									<div className="columns">
										<div className="column is-1">
											<i className="fa fa-calendar" />
										</div>
										<div className="column">
											<span className="help is-dark">Periodo de ejecución</span>
											<strong>{_.capitalize(moment(summary.data.execution_start).format('MMMM YYYY'))} a {_.capitalize(moment(summary.data.execution_end).format('MMMM YYYY'))}</strong>
										</div>
									</div>
								</td>
							</tr>
							</tbody>
						</table>

						<h1 className="title is-6">METAS DEL PROYECTO</h1>
						{_.map(financial.data.proigualdad_axis, (axis, key) => {
							return[
								<Fieldset key={`table-`+key} model={`.reports.financial.body.goals`} component="table" className="table is-fullwidth project-goal-table no-margin">
									{_.map(axis.project_goals, (row, k) => {
										let validCdm = false; let versionPhaseGoal= undefined; let agencyId = undefined;
										let findAgency = undefined;
										let goalDocument = undefined; let goalInvoices = undefined; let validGoalShow = undefined;
										let goalRevision = !_.isEmpty(revision.reports.financial.body) && !_.isEmpty(revision.reports.financial.body.goals) && !_.isEmpty(revision.reports.financial.body.goals[row.id]) ? revision.reports.financial.body.goals[row.id]: undefined
										let goalRevisionAllowEdit = goalRevision && !_.isEmpty(goalRevision.allow_edit) ? goalRevision.allow_edit:'false';
										let goalRevisionCdm = undefined; let goalRevisionCdmAllowEdit = 'false';
										let styleActionGoalButton = {
											display: 'inline',
											//marginBottom: '7px',
											border: 0,
											backgroundColor: 'transparent',
											color: '#662d91',
											cursor: 'pointer'
										}
										if(modality !== 'modalidad-iii'){
											validGoalShow = true;
											versionPhaseGoal = !_.isArray(row.project_version_phase_goal) ? row.project_version_phase_goal:undefined;
											goalInvoices = versionPhaseGoal;
											goalDocument = !_.isEmpty(versionPhaseGoal) && !_.isEmpty(versionPhaseGoal.documents) ? _.filter(versionPhaseGoal.documents, {documentable_subtype: "goal_document"}):undefined;
										}else {
											validCdm = !_.isEmpty(revision.reports.financial.agency) && !_.isEmpty(revision.reports.financial.agency[key])  && !_.isEmpty(revision.reports.financial.agency[key][k]) && revision.reports.financial.agency[key][k].id !== '' ? true:false;
											agencyId = validCdm ? _.toNumber(revision.reports.financial.agency[key][k].id):undefined;
											versionPhaseGoal = !_.isEmpty(row.project_version_phase_goal) &&  validCdm ? _.find(row.project_version_phase_goal, {agency_id: agencyId}):undefined;
											goalDocument = versionPhaseGoal && !_.isEmpty(versionPhaseGoal.documents) ? _.filter(versionPhaseGoal.documents, {documentable_subtype: "goal_document"}):undefined
											validGoalShow = _.isNumber(agencyId) ? true:false;
											goalRevisionCdm = agencyId && !_.isEmpty(revision.reports.financial.body) && !_.isEmpty(revision.reports.financial.body.goals) && !_.isEmpty(revision.reports.financial.body.goals[row.id]) && !_.isEmpty(revision.reports.financial.body.goals[row.id].agencies[agencyId]) ? revision.reports.financial.body.goals[row.id].agencies[agencyId]: undefined;
											goalRevisionCdmAllowEdit = goalRevisionCdm && !_.isEmpty(goalRevisionCdm.allow_edit) ? goalRevisionCdm.allow_edit:'false';
											findAgency = _.find(row.agencies, {id: agencyId})

											if(Boolean(row.requires_employees)){
												goalInvoices = versionPhaseGoal;
											}else {
												goalInvoices = !_.isEmpty(row.project_version_phase_goal) ? _.find(row.project_version_phase_goal, {agency_id: financial.data.agency_id}):undefined;
											}

											if(validGoalShow){
												styleActionGoalButton = {
													...styleActionGoalButton,
												}
											}else {
												styleActionGoalButton = {
													...styleActionGoalButton,
													color: 'grey',
													cursor: 'not-allowed'
												}
											}
										}

										return(
											<tbody key={k}>
											<tr>
												<td colSpan={3} className="goal-cell">
													<span className="help is-white">Eje temático</span>
													<strong>{row && row.axis ? row.axis.name : '---'}</strong>
												</td>
											</tr>
											{modality === 'modalidad-iii' ?
												<tr>
													<td colSpan={3}>
														<div className="field is-grouped">
															<div className="control">
																<label htmlFor={`agency_id_${k}`} className="label">CDM'S</label>
																<div className="select is-small">
																	<Control.select model={`revision.reports.financial.agency[${key}][${k}].id`} name={`agency_id_${k}`} id={`agency_id_${k}`}>
																		<option value=""> -- CDM'S --</option>
																		{_.map(row.agencies,(cdm, o) => {
																			let cdmStatus = _.find(row.project_version_phase_goal, {agency_id: cdm.id});
																			return <option key={o} value={cdm.id} className={cdmStatus && cdmStatus.status ? `has-text-${cdmStatus.status.style}`:''}>{cdm.agenciable && cdm.agenciable.name ? cdm.agenciable.name:'---'}</option>
																		})}
																	</Control.select>
																</div>
															</div>

															<div className="control">
																<div className="notification is-info">
																	<p><i className="fa fa-info"/>&nbsp; Seleccionar CDM para llenar revisión </p>
																</div>
															</div>
														</div>
													</td>
												</tr>
												:null}
											<tr>
												<td colSpan={3}>
													<span className="help is-dark">Línea de acción</span>
													<small><strong>{row && row.line ? row.line.name : '---'}</strong></small>
												</td>
											</tr>
											<tr>
												<td rowSpan={3}>
													<span className="help is-inm-purple">Código</span>
													<strong className="has-text-inm-purple">{row.code}</strong>
												</td>
												<td style={{width: '70%',padding: '0em .5em 1em 30px'}}>
													<div className="control" style={styleActions}>
														{validGoalShow ?
															<p className="field-notification" style={{
																backgroundColor: '#fff',
																top: '-' + 100 + '%',
																transform: 'translateY(-100%)'}}>
																<b>Estatus</b><br/>
																{versionPhaseGoal && versionPhaseGoal.status_id !== 0 && versionPhaseGoal.status_id !== 1 ? <strong><span className={`has-text-${versionPhaseGoal.status.style}`}>{versionPhaseGoal.status.name}</span></strong>:<span>Sin estatus</span>}<br/>
																<b>Motivo</b><br/>
																{versionPhaseGoal && versionPhaseGoal.status_motive ? versionPhaseGoal.status_motive.name:'N/A'}
															</p>
															:''}
														<button type="button" style={styleActionGoalButton} disabled={validGoalShow ? false:true}><i className="fa fa-eye"></i></button>
													</div>
													<span className="help is-dark">Meta</span>
													<strong>{row.name}</strong>
												</td>
												<td style={{padding: '0em .5em 1em 30px'}}>
													{this.state.modalMessageExpensesGoalShow && key === this.state.axisIndex && k === this.state.goalIndex ?
														<ModalMessageExpenseGoal active={this.state.modalMessageExpensesGoalShow} amounts={row.amounts} data={goalInvoices} findAgency={findAgency} closeModal={() => this._toggleModal()} {...this.props}/> : ''}
													<div className="actions" style={styleActions}>
														<div className="control">
															<button type="button" style={styleActionGoalButton} onClick={() => this._showMessageExpensesGoal(key, k)}><i className="fa fa-eye"></i></button>
														</div>
													</div>
													<span className="help is-dark">Gastos</span>
													{/*<span className="help is-inm-purple">Monto aprobado</span>
													<strong>{formatMoney(row.amounts.total)}</strong>*/}
													<span className="help is-inm-purple">Monto ejercido</span>
													<strong>{formatMoney(row.amounts.spent)}</strong>
													<span className="help is-inm-purple">Monto por ejercer</span>
													<strong>{formatMoney(row.amounts.missing)}</strong>
												</td>
											</tr>
											<tr>
												<td >
													<span className="help is-dark">Concepto de gasto</span>
													<small><strong>{row.resource_concept ? row.resource_concept.name : ''}</strong></small>
												</td>
												<td rowSpan={2}>
													{this.state.modalMessageActorsGoalShow && key === this.state.axisIndex && k === this.state.goalIndex ?
														<ModalMessageActors active={this.state.modalMessageActorsGoalShow} actors={row.actors} closeModal={() => this._toggleModal()}/> : ''}
													{/* {this.state.modalMessageConagoGoalShow && key === this.state.axisIndex && k === this.state.goalIndex ?
														<ModalMessageConago active={this.state.modalMessageConagoGoalShow} conago_clauses={row.conago_clauses} closeModal={() => this._toggleModal()}/> : ''} */}
													{/* {modality === 'modalidad-i' ?
													<div className="tags has-addons" style={{cursor:'pointer'}} onClick={() => this._showMessageConago(key, k)}>
														<span className="tag is-light" >Metas CONAGO</span>
														<span className="tag is-white">{_.size(row.conago_clauses)}</span>
													</div>
													:''} */}
													<div className="tags has-addons" style={{cursor:'pointer'}} onClick={() => this._showMessageActors(key, k)}>
														<span className="tag is-light" >Actores estratégicos</span>
														<span className="tag is-white">{_.size(row.actors)}</span>
													</div>

													{this.state.modalMessageConagoGoalShow && key === this.state.axisIndex && k === this.state.goalIndex ?
														<ModalMessageConago active={this.state.modalMessageConagoGoalShow} project_goal_activities={row.project_goal_activities} closeModal={() => this._toggleModal()}/> : ''}
													<div className="tags has-addons" style={{cursor:'pointer'}}  onClick={() => this._showMessageConago(key,k)}>
														<span className="tag is-light" >
															{/* <i className="fa fa-users"></i> */}
															Personas atendidas
														</span>
														<span className="tag is-white">
															{`${sum_personas_atendidas(row.project_goal_activities)}`}
														</span>
													</div>
												</td>
											</tr>
											<tr>
												<td style={{padding: '0em .5em 1em 30px'}}>
													{this.state.modalMessageDocumentGoalShow && key === this.state.axisIndex && k === this.state.goalIndex ? <ModalMessageDocumentGoal active={this.state.modalMessageDocumentGoalShow} goalDocument={goalDocument} closeModal={() => this._toggleModal()} {...this.props}/> : ''}
													<div className="control" style={styleActions}>
														<button type="button" style={styleActionGoalButton} onClick={() => this._showMessageDocument(key, k)} disabled={validGoalShow ? false:true}><i className="fa fa-eye"></i></button>
													</div>
													<span className="help is-dark">Medios de Verificación</span>
													<small><strong>{row.goal_document}</strong></small>
												</td>
											</tr>
											{validGoalShow ?
												<tr>
													<td colSpan={3}>
														<span className="help is-dark">{`Revisión de la meta ${row.code}`}</span>
														<div className="field has-addons">
															<div className="control">
																<div className="select is-small">
																	<Control model={`[${row.id}].status`} key={`status_${row.id}`} id={`status_${row.id}`} component={NotificationStatus} defaultValue={goalRevision && goalRevision.status ? goalRevision.status : 'success'} changeAction={(model,value) => this._changeStatus(model,value, {id: row.id, model:`revision.reports.financial.body.goals[${row.id}].id`})} />
																</div>
															</div>
															<div className="control is-expanded">
																<Control.text model={`[${row.id}].comment`} key={`comment_${row.id}`} id={`comment_${row.id}`} className="input is-small is-fullwidth" placeholder="Comentario"/>
															</div>
															<div className="control">
																<div className="select is-small">
																	<Control model={`[${row.id}].allow_edit`} key={`edit_status_${row.id}`} id={`edit_status_${row.id}`} component={EditStatus} defaultValue={goalRevisionAllowEdit} />
																</div>
															</div>
														</div>
													</td>
												</tr>
												:null}
											{modality === 'modalidad-iii' ?
											findAgency ?
											<tr>
												<td colSpan={3}>
													<span className="help is-dark">{`Revisión de la meta ${row.code} por CDM - ${findAgency.agenciable.name}`}</span>
													<div className="field has-addons">
														<div className="control">
															<div className="select is-small">
																<Control model={`[${row.id}].agencies[${agencyId}].status`} key={`status_${row.id}_rev${agencyId}`} id={`status_${row.id}_rev${agencyId}`}  component={NotificationStatus} defaultValue={goalRevisionCdm && goalRevisionCdm.status ? goalRevisionCdm.status : 'success'} changeAction={(model,value) => this._changeStatus(model,value, {id: row.id, model:`revision.reports.financial.body.goals[${row.id}].agencies[${agencyId}].id`})} />
															</div>
														</div>
														<div className="control is-expanded">
															<Control.text model={`[${row.id}].agencies[${agencyId}].comment`} key={`comment_${row.id}_rev${agencyId}`} id={`comment_${row.id}_rev${agencyId}`} className="input is-small is-fullwidth" placeholder="Comentario"/>
														</div>
														<div className="control">
															<div className="select is-small">
																<Control model={`[${row.id}].agencies[${agencyId}].allow_edit`} key={`edit_status_${row.id}_rev${agencyId}`} id={`edit_status_${row.id}_rev${agencyId}`} component={EditStatus} defaultValue={goalRevisionCdmAllowEdit}/>
															</div>
														</div>
													</div>
												</td>
											</tr>
											:null
											:null}
											{validGoalShow ?
											<Fieldset model={`[${row.id}]${modality === 'modalidad-iii' && findAgency ? `.agencies[${agencyId}]`:''}.activities`} component="tr">
												<td colSpan={3}>
													<table className="table is-fullwidth project-activity-table">
														<thead>
														<tr>
															<th>ID</th>
															<th>Actividad</th>
															{/* <th>Medio de verificación</th> */}
														</tr>
														</thead>
														<tbody>
														{_.map(row.project_goal_activities,(activity, o) => {
															let actRevision = undefined;
															let actRevisionAllowedit = undefined;
															let versionPhaseGoalActivity = undefined;
															let activityDocument = undefined;
															//goalRevisionCdm
															if(modality !== 'modalidad-iii'){
																actRevision = goalRevision && !_.isEmpty(goalRevision.activities) && !_.isEmpty(goalRevision.activities[activity.id]) ? goalRevision.activities[activity.id]: undefined;
																actRevisionAllowedit = actRevision && !_.isEmpty(actRevision.allow_edit) ? actRevision.allow_edit:'false';
																versionPhaseGoalActivity = !_.isArray(activity.project_version_phase_goal_activity) ? activity.project_version_phase_goal_activity:undefined;
																activityDocument = !_.isEmpty(versionPhaseGoalActivity) && !_.isEmpty(versionPhaseGoalActivity.documents) ? _.filter(versionPhaseGoalActivity.documents, {documentable_subtype: "verification_media"}):undefined;
															}else {
																actRevision = goalRevisionCdm && !_.isEmpty(goalRevisionCdm.activities) && !_.isEmpty(goalRevisionCdm.activities[activity.id]) ? goalRevisionCdm.activities[activity.id]: undefined;
																actRevisionAllowedit = actRevision && !_.isEmpty(actRevision.allow_edit) ? actRevision.allow_edit:'false';
																versionPhaseGoalActivity = validCdm ? _.find(activity.project_version_phase_goal_activity, {agency_id: _.toNumber(agencyId)}):undefined;
																activityDocument = !_.isEmpty(versionPhaseGoalActivity) && !_.isEmpty(versionPhaseGoalActivity.documents) ? _.filter(versionPhaseGoalActivity.documents, {documentable_subtype: "verification_media"}):undefined
															}
															return [
																<tr key={o}>
																	<td>{activity.proigualdad_activity_id}</td>
																	<td style={{padding: '0em .5em 1em 30px'}}>
																		<div className="control" style={styleActionsActivity}>
																			<p className="field-notification"
																			   style={{
																				   backgroundColor: '#fff',
																				   top: '-' + 100 + '%',
																				   transform: 'translateY(-100%)'
																			   }}>
																				<b>Estatus</b><br/>
																				{versionPhaseGoalActivity && versionPhaseGoalActivity.status_id !== 0 && versionPhaseGoalActivity.status_id !== 1 ? <strong><span className={`has-text-${versionPhaseGoalActivity.status.style}`}>{versionPhaseGoalActivity.status.name}</span></strong>:<span>Sin estatus</span>}<br/>
																				<b>Motivo</b><br/>
																				{versionPhaseGoalActivity && versionPhaseGoalActivity.status_motive ? versionPhaseGoalActivity.status_motive.name:'N/A'}
																			</p>
																			<button type="button" style={styleActionGoalButton}><i className="fa fa-eye"/></button>
																		</div>
																		{activity.name}
																	</td>
																	{/* <td style={{padding: '0em .5em 1em 30px'}}>
																		{this.state.modalMessageMediaActivityShow && key === this.state.axisIndex && k === this.state.goalIndex && o === this.state.activityIndex ?
																			<ModalMessageMediaActivity active={this.state.modalMessageMediaActivityShow} activityDocument={activityDocument} closeModal={() => this._toggleModal()} {...this.props}/> : ''}
																		<div className="control" style={styleActionsActivity}>
																			<button type="button" style={styleActionGoalButton} onClick={() => this._showMessageMedia(key, k, o)}><i className="fa fa-eye"></i></button>
																		</div>
																		{activity.verification_media ? activity.verification_media.name : '---'}
																	</td> */}
																</tr>,
																<tr key={`rev-${o}`}>
																	<td colSpan={3}>
																		<span className="help is-dark">{`Revisión de la actividad ${activity.proigualdad_activity_id}${modality === 'modalidad-iii' && findAgency ? ` por CDM - ${findAgency.agenciable.name}`:''}`}</span>
																		<div className="field has-addons">
																			<div className="control">
																				<div className="select is-small">
																					<Control model={`[${activity.id}].status`} key={`status_${row.id}${agencyId ? `_rev${agencyId}`:''}`} id={`status_${row.id}${agencyId ? `_rev${agencyId}`:''}`} component={NotificationStatus} defaultValue={actRevision && actRevision.status ? actRevision.status : 'success'} changeAction={(model,value) => { this._changeStatus(model,value, {id: activity.id, model:`revision.reports.financial.body.goals[${row.id}]${modality === 'modalidad-iii' && findAgency ? `.agencies[${_.toNumber(agencyId)}]`:''}.activities[${activity.id}].id`});}} />
																				</div>
																			</div>
																			<div className="control is-expanded">
																				<Control.text model={`[${activity.id}].comment`} key={`comment_${row.id}${agencyId ? `_rev${agencyId}`:''}`} id={`comment_${row.id}${agencyId ? `_rev${agencyId}`:''}`}  className="input is-small is-fullwidth" placeholder="Comentario"/>
																			</div>
																			<div className="control">
																				<div className="select is-small">
																					<Control model={`[${activity.id}].allow_edit`} key={`edit_status_${row.id}${agencyId ? `_rev${agencyId}`:''}`} id={`edit_status_${row.id}${agencyId ? `_rev${agencyId}`:''}`} defaultValue={actRevisionAllowedit}  component={EditStatus}/>
																				</div>
																			</div>
																		</div>
																	</td>
																</tr>
															]
														})}
														</tbody>
													</table>
												</td>
											</Fieldset>
											:null}
											</tbody>
										)
									})}
								</Fieldset>
							]
						})}

						{!_.isEmpty(revision.notifications_types) ?
							<div className="fieldset">
								<legend>NOTIFICACIÓN</legend>
								<div className="columns">
									<div className="column">
										<div className="field is-grouped is-grouped-multiline">
											<div className="control">
												<label htmlFor="" className="label">Tipo de notificación</label>
												<div className="select">
													<Control.select model="revision.reports.financial.notification_type_id" id="notification_type_id" >
														<option value="" defaultValue>--- Tipo ---</option>
														{_.map(revision.notifications_types, (opc, k) => {
															return <option value={opc.id} key={k}>{opc.name}</option>
														})}
													</Control.select>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							:''}

						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button type="button" className="button is-large" onClick={() => this.props.history.goBack()}>
									Regresar
								</button>
							</div>

							{rc ?
							<div className="control">
								<Control.button model="revision" className="button is-large is-primary">
									Guardar
								</Control.button>
							</div> :''}
						</div>
					</Form>
				</div>
			</div>
		)
	}

	constructor() {
		super();
		this.state = {
			axisIndex: undefined,
			goalIndex: undefined,
			activityIndex: undefined,
			modalMessageExpensesGoalShow: false,
			modalMessageDocumentGoalShow: false,
			modalMessageMediaActivityShow: false,
			modalMessageActorsGoalShow: false,
			modalMessageConagoGoalShow: false
		}
	}

	_submitForm(values){
		let { modality, state, municipality } = this.props.match.params;
		this.props.saveRevisionReportsFinancial(modality, state, municipality, values);
	}

	_stateName() {
		let { entities, reports } = this.props;
		if(!_.isEmpty(reports.summary.data)){
			let state = _.find(entities.list, {id: reports.summary.data.agency.agenciable.state_id});
			return state ? state.name : '---'
		}
	}

	_changeStatus(model, values, field) {
		this.props.change(model, values);
		this.props.change(field.model, field.id);
	}

	_showMessageExpensesGoal(indexAxis, indexGoal){
		this.setState({
			modalMessageExpensesGoalShow: true,
			axisIndex: indexAxis,
			goalIndex: indexGoal
		})
	}

	_showMessageDocument(indexAxis, indexGoal){
		this.setState({
			modalMessageDocumentGoalShow: true,
			axisIndex: indexAxis,
			goalIndex: indexGoal
		})
	}

	_showMessageMedia(indexAxis, indexGoal, indexActivity){
		this.setState({
			modalMessageMediaActivityShow: true,
			axisIndex: indexAxis,
			goalIndex: indexGoal,
			activityIndex: indexActivity
		})
	}

	_showMessageActors(indexAxis, indexGoal){
		this.setState({
			modalMessageActorsGoalShow: true,
			axisIndex: indexAxis,
			goalIndex: indexGoal
		})
	}

	_showMessageConago(indexAxis, indexGoal){
		this.setState({
			modalMessageConagoGoalShow: true,
			axisIndex: indexAxis,
			goalIndex: indexGoal
		})
	}

	_toggleModal() {
		this.setState({
			modalMessageExpensesGoalShow: false,
			modalMessageDocumentGoalShow: false,
			modalMessageMediaActivityShow: false,
			modalMessageActorsGoalShow: false,
			modalMessageConagoGoalShow: false
		});
	}
}

class ModalMessageExpenseGoal extends Component {
	render(){
		let { data, amounts, match, findAgency } = this.props;
		let {modality} = match.params;
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}></div>
				<div className="modal-content" style={{height: (!_.isEmpty(data) && _.isEmpty(data.invoices)) || (_.isEmpty(data)) ? 'auto':''}}>
					<div className="message">
						<div className="message-header">
							<p>Gastos de la meta{modality === 'modalidad-iii' && findAgency  ? ` por CDM - ${findAgency.agenciable.name}`:''}</p>
							<button className="delete" aria-label="delete" onClick={this.props.closeModal}></button>
						</div>
						<div className="message-body">
							<div className="columns">
								<div className="column is-6">
									<p>Monto aprobado</p>
									<p><strong>{formatMoney(amounts.total)}</strong></p>
								</div>
								<div className="column is-6">
									<p>Monto ejercido</p>
									<p><strong>{formatMoney(amounts.spent)}</strong></p>
								</div>
							</div>

							<div className="columns">
								{modality === 'modalidad-iii' && data && !_.isEmpty(data.amounts) ?
									<div className="column is-6">
										<p>{`Monto ejercido - ${findAgency.agenciable.name}`}</p>
										<p><strong>{formatMoney(data.amounts.spent_total)}</strong></p>
									</div>
									:''}
								<div className="column is-6">
									<p>Monto por ejercer</p>
									<p><strong>{formatMoney(amounts.missing)}</strong></p>
								</div>
							</div>

							{!_.isEmpty(data) && !_.isEmpty(data.invoices) ?
								<fieldset className="fieldset">
									<legend>Facturas</legend>
									<table className="inm-table">
										<thead>
										<tr>
											<th>Factura</th>
											<th>PDF</th>
											<th>XML</th>
											<th>SAT</th>
										</tr>
										</thead>
										<tbody>
										{_.map(data.invoices, (item,k) => {
											return(
												<tr key={k}>
													<td>{`${item.date} - ${formatMoney(item.total)}`}</td>

													<td>
														<div className="control">
															<a href={item.pdf}  className="button is-info" target="_blank">
																<span className="icon"><i className="fa fa-eye"/></span>
															</a>
														</div>
													</td>

													<td>
														<div className="control">
															<a href={item.xml}  className="button is-info" target="_blank">
																<span className="icon"><i className="fa fa-eye"/></span>
															</a>
														</div>
													</td>

													<td>
														<div className="control">
															<a href={item.sat}  className="button is-info" target="_blank">
																<span className="icon"><i className="fa fa-eye"/></span>
															</a>
														</div>
													</td>
												</tr>
											)
										})}
										</tbody>
									</table>
								</fieldset>
								:''}
						</div>
					</div>
				</div>
				<button className="modal-close is-large" aria-label="close" onClick={this.props.closeModal}></button>
			</div>
		)
	}
}

class ModalMessageDocumentGoal extends Component {
	render(){
		let { goalDocument } = this.props;
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}></div>
				<div className="modal-content" style={{height: _.isEmpty(goalDocument) ? 'auto':''}}>
					<div className="message">
						<div className="message-header">
							<p>Documentos meta</p>
							<button className="delete" aria-label="delete" onClick={this.props.closeModal}></button>
						</div>
						<div className="message-body">
							<p>El documento generado da cumplimiento a los requerimientos de las Reglas de Operación y fue realizado a entera satisfacción</p>
							<br/>
							<p><strong>{goalDocument ? 'Si':'---'}</strong></p>
							<p>¿Las temáticas abordadas y las aportaciones realizadas en los eventos desarrollados (talleres, mesas de trabajo y otros) fueron incluidas en el documento meta?</p>
							<br/>
							<p><strong>{goalDocument ? 'Si':'---'}</strong></p><br/>
							<p><strong>Archivos</strong></p>
							{goalDocument ?
								_.map(goalDocument, (item, k) => {
									return[
										<a href={item.file} key={k} target="_blank">
											{`Archivo - ${k+1}`}
										</a>,
										<br key={'br_'+k}/>
									]
								})
								:''}
						</div>
					</div>
				</div>
				<button className="modal-close is-large" aria-label="close" onClick={this.props.closeModal}></button>
			</div>
		)
	}
}

class ModalMessageMediaActivity extends Component {
	render(){
		let { activityDocument } = this.props;
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}></div>
				<div className="modal-content" style={{height: _.isEmpty(activityDocument) ? 'auto':''}}>
					<div className="message">
						<div className="message-header">
							<p>Medio de verificación</p>
							<button className="delete" aria-label="delete" onClick={this.props.closeModal}></button>
						</div>
						<div className="message-body">
							<p><strong>Archivos</strong></p>
							{activityDocument ?
								_.map(activityDocument, (item, k) => {
									return[
										<a href={item.file} key={k} target="_blank">
											{`Archivo - ${k+1}`}
										</a>,
										<br key={'br_'+k}/>
									]
								})
								:<p><strong>---</strong></p>}
						</div>
					</div>
				</div>
				<button className="modal-close is-large" aria-label="close" onClick={this.props.closeModal}></button>
			</div>
		)
	}
}

class ModalMessageActors extends Component {
	render() {
		let { actors } = this.props;
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}/>
				<div className="modal-content">
					<div className="message">
						<div className="message-header">
							<p>Actores estratégicos que aplican</p>
							<button type="button" onClick={this.props.closeModal} className="delete is-medium" aria-label="delete"></button>
						</div>
						<div className="message-body">
							<ul>
								{_.map(actors, (item,k) => {
									return (
										<li key={k} type="disc"><label className="label" >{item.name}</label></li>
									)
								})}
							</ul>

							<br /><br />
							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button className="button is-info" type="button" onClick={this.props.closeModal}>Cerrar</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<button className="modal-close is-large" aria-label="close" onClick={this.props.closeModal}></button>
			</div>
		)
	}
}

class ModalMessageConago extends Component {
	render() {
		let { project_goal_activities } = this.props;
		let persons_total = {
			"count_person_f_1_1": 0,
			"count_person_f_1_2": 0,
			"count_person_f_1_3": 0,
			"count_person_f_1_4": 0,
			"count_person_f_1_5": 0,
			"count_person_m_1_1": 0,
			"count_person_m_1_2": 0,
			"count_person_m_1_3": 0,
			"count_person_m_1_4": 0,
			"count_person_m_1_5": 0,
			"count_person_o_1_1": 0,
			"count_person_o_1_2": 0,
			"count_person_o_1_3": 0,
			"count_person_o_1_4": 0,
			"count_person_o_1_5": 0,
			"count_person_f_2_1": 0,
			"count_person_f_2_2": 0,
			"count_person_f_2_3": 0,
			"count_person_f_2_4": 0,
			"count_person_f_2_5": 0,
			"count_person_m_2_1": 0,
			"count_person_m_2_2": 0,
			"count_person_m_2_3": 0,
			"count_person_m_2_4": 0,
			"count_person_m_2_5": 0,
			"count_person_o_2_1": 0,
			"count_person_o_2_2": 0,
			"count_person_o_2_3": 0,
			"count_person_o_2_4": 0,
			"count_person_o_2_5": 0,
			"count_person_f_3_1": 0,
			"count_person_f_3_2": 0,
			"count_person_f_3_3": 0,
			"count_person_f_3_4": 0,
			"count_person_f_3_5": 0,
			"count_person_m_3_1": 0,
			"count_person_m_3_2": 0,
			"count_person_m_3_3": 0,
			"count_person_m_3_4": 0,
			"count_person_m_3_5": 0,
			"count_person_o_3_1": 0,
			"count_person_o_3_2": 0,
			"count_person_o_3_3": 0,
			"count_person_o_3_4": 0,
			"count_person_o_3_5": 0,
			"count_person_f_4_1": 0,
			"count_person_f_4_2": 0,
			"count_person_f_4_3": 0,
			"count_person_f_4_4": 0,
			"count_person_f_4_5": 0,
			"count_person_m_4_1": 0,
			"count_person_m_4_2": 0,
			"count_person_m_4_3": 0,
			"count_person_m_4_4": 0,
			"count_person_m_4_5": 0,
			"count_person_o_4_1": 0,
			"count_person_o_4_2": 0,
			"count_person_o_4_3": 0,
			"count_person_o_4_4": 0,
			"count_person_o_4_5": 0,
			"count_person_f_5_1": 0,
			"count_person_f_5_2": 0,
			"count_person_f_5_3": 0,
			"count_person_f_5_4": 0,
			"count_person_f_5_5": 0,
			"count_person_m_5_1": 0,
			"count_person_m_5_2": 0,
			"count_person_m_5_3": 0,
			"count_person_m_5_4": 0,
			"count_person_m_5_5": 0,
			"count_person_o_5_1": 0,
			"count_person_o_5_2": 0,
			"count_person_o_5_3": 0,
			"count_person_o_5_4": 0,
			"count_person_o_5_5": 0
		};
		// here
		let total_count_person = 0;
		if(project_goal_activities){
			for(let i=0; i < project_goal_activities.length ;i++){
				if(project_goal_activities[i]['persons'] && project_goal_activities[i]['persons'] !== null && project_goal_activities[i]['persons'] !== undefined && project_goal_activities[i]['persons'].length > 0){
					for(let j=0; j < project_goal_activities[i]['persons'].length ;j++){
						for(let key of Object.keys(persons_total)){
							if (project_goal_activities[i]['persons'][j][key] && project_goal_activities[i]['persons'][j][key] !== undefined) {
								persons_total[key] += parseInt(project_goal_activities[i]['persons'][j][key]);
								total_count_person += parseInt(project_goal_activities[i]['persons'][j][key])
							}
						}
					}
				}
			}
		}
		return (
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}/>
				<div className="modal-content" style={{width: '90%'}}>
					<div className="message">
						<div className="message-header">
							<p>Personas atendidas en la Meta</p>
							<button type="button" onClick={this.props.closeModal} className="delete is-medium" aria-label="delete"></button>
						</div>
						<div className="message-body">
							<div className="columns is-multiline">
							<div className="column is-4">
									<fieldset className="fieldset">
										<legend><b>Total</b></legend>
										<table className="inm-table">
											<thead>
											<tr>
												<th>Grupo etario</th>
												<th>Mujeres</th>
												<th>Hombres</th>
												<th>Otros</th>
												<th><b>Total</b></th>
											</tr>
											</thead>
											<tbody>
												<tr>
													<td>0 a 14</td>
													<td>{persons_total['count_person_f_1_1'] + persons_total['count_person_f_2_1'] + persons_total['count_person_f_3_1'] + persons_total['count_person_f_4_1'] + persons_total['count_person_f_5_1']}</td>
													<td>{persons_total['count_person_m_1_1'] + persons_total['count_person_m_2_1'] + persons_total['count_person_m_3_1'] + persons_total['count_person_m_4_1'] + persons_total['count_person_m_5_1']}</td>
													<td>{persons_total['count_person_o_1_1'] + persons_total['count_person_o_2_1'] + persons_total['count_person_o_3_1'] + persons_total['count_person_o_4_1'] + persons_total['count_person_o_5_1']}</td>

													<td>{persons_total['count_person_f_1_1'] + persons_total['count_person_f_2_1'] + persons_total['count_person_f_3_1'] + persons_total['count_person_f_4_1'] + persons_total['count_person_f_5_1'] + persons_total['count_person_m_1_1'] + persons_total['count_person_m_2_1'] + persons_total['count_person_m_3_1'] + persons_total['count_person_m_4_1'] + persons_total['count_person_m_5_1'] + persons_total['count_person_o_1_1'] + persons_total['count_person_o_2_1'] + persons_total['count_person_o_3_1'] + persons_total['count_person_o_4_1'] + persons_total['count_person_o_5_1']}</td>
												</tr>
												<tr>
													<td>15 a 29</td>
													<td>{persons_total['count_person_f_1_2'] + persons_total['count_person_f_2_2'] + persons_total['count_person_f_3_2'] + persons_total['count_person_f_4_2'] + persons_total['count_person_f_5_2']}</td>
													<td>{persons_total['count_person_m_1_2'] + persons_total['count_person_m_2_2'] + persons_total['count_person_m_3_2'] + persons_total['count_person_m_4_2'] + persons_total['count_person_m_5_2']}</td>
													<td>{persons_total['count_person_o_1_2'] + persons_total['count_person_o_2_2'] + persons_total['count_person_o_3_2'] + persons_total['count_person_o_4_2'] + persons_total['count_person_o_5_2']}</td>

													<td>{persons_total['count_person_f_1_2'] + persons_total['count_person_f_2_2'] + persons_total['count_person_f_3_2'] + persons_total['count_person_f_4_2'] + persons_total['count_person_f_5_2'] + persons_total['count_person_m_1_2'] + persons_total['count_person_m_2_2'] + persons_total['count_person_m_3_2'] + persons_total['count_person_m_4_2'] + persons_total['count_person_m_5_2'] + persons_total['count_person_o_1_2'] + persons_total['count_person_o_2_2'] + persons_total['count_person_o_3_2'] + persons_total['count_person_o_4_2'] + persons_total['count_person_o_5_2']}</td>
												</tr>
												<tr>
													<td>30 a 44</td>
													<td>{persons_total['count_person_f_1_3'] + persons_total['count_person_f_2_3'] + persons_total['count_person_f_3_3'] + persons_total['count_person_f_4_3'] + persons_total['count_person_f_5_3']}</td>
													<td>{persons_total['count_person_m_1_3'] + persons_total['count_person_m_2_3'] + persons_total['count_person_m_3_3'] + persons_total['count_person_m_4_3'] + persons_total['count_person_m_5_3']}</td>
													<td>{persons_total['count_person_o_1_3'] + persons_total['count_person_o_2_3'] + persons_total['count_person_o_3_3'] + persons_total['count_person_o_4_3'] + persons_total['count_person_o_5_3']}</td>

													<td>{persons_total['count_person_f_1_3'] + persons_total['count_person_f_2_3'] + persons_total['count_person_f_3_3'] + persons_total['count_person_f_4_3'] + persons_total['count_person_f_5_3'] + persons_total['count_person_m_1_3'] + persons_total['count_person_m_2_3'] + persons_total['count_person_m_3_3'] + persons_total['count_person_m_4_3'] + persons_total['count_person_m_5_3'] + persons_total['count_person_o_1_3'] + persons_total['count_person_o_2_3'] + persons_total['count_person_o_3_3'] + persons_total['count_person_o_4_3'] + persons_total['count_person_o_5_3']}</td>
												</tr>
												<tr>
													<td>45 a 59</td>
													<td>{persons_total['count_person_f_1_4'] + persons_total['count_person_f_2_4'] + persons_total['count_person_f_3_4'] + persons_total['count_person_f_4_4'] + persons_total['count_person_f_5_4']}</td>
													<td>{persons_total['count_person_m_1_4'] + persons_total['count_person_m_2_4'] + persons_total['count_person_m_3_4'] + persons_total['count_person_m_4_4'] + persons_total['count_person_m_5_4']}</td>
													<td>{persons_total['count_person_o_1_4'] + persons_total['count_person_o_2_4'] + persons_total['count_person_o_3_4'] + persons_total['count_person_o_4_4'] + persons_total['count_person_o_5_4']}</td>

													<td>{persons_total['count_person_f_1_4'] + persons_total['count_person_f_2_4'] + persons_total['count_person_f_3_4'] + persons_total['count_person_f_4_4'] + persons_total['count_person_f_5_4'] + persons_total['count_person_m_1_4'] + persons_total['count_person_m_2_4'] + persons_total['count_person_m_3_4'] + persons_total['count_person_m_4_4'] + persons_total['count_person_m_5_4'] + persons_total['count_person_o_1_4'] + persons_total['count_person_o_2_4'] + persons_total['count_person_o_3_4'] + persons_total['count_person_o_4_4'] + persons_total['count_person_o_5_4']}</td>
												</tr>
												<tr>
													<td>60 o más</td>
													<td>{persons_total['count_person_f_1_5'] + persons_total['count_person_f_2_5'] + persons_total['count_person_f_3_5'] + persons_total['count_person_f_4_5'] + persons_total['count_person_f_5_5']}</td>
													<td>{persons_total['count_person_m_1_5'] + persons_total['count_person_m_2_5'] + persons_total['count_person_m_3_5'] + persons_total['count_person_m_4_5'] + persons_total['count_person_m_5_5']}</td>
													<td>{persons_total['count_person_o_1_5'] + persons_total['count_person_o_2_5'] + persons_total['count_person_o_3_5'] + persons_total['count_person_o_4_5'] + persons_total['count_person_o_5_5']}</td>

													<td>{persons_total['count_person_f_1_5'] + persons_total['count_person_f_2_5'] + persons_total['count_person_f_3_5'] + persons_total['count_person_f_4_5'] + persons_total['count_person_f_5_5'] + persons_total['count_person_m_1_5'] + persons_total['count_person_m_2_5'] + persons_total['count_person_m_3_5'] + persons_total['count_person_m_4_5'] + persons_total['count_person_m_5_5'] + persons_total['count_person_o_1_5'] + persons_total['count_person_o_2_5'] + persons_total['count_person_o_3_5'] + persons_total['count_person_o_4_5'] + persons_total['count_person_o_5_5']}</td>
												</tr>
												<tr>
													<td><b>TOTAL:</b></td>
													<td></td>
													<td></td>
													<td></td>
													<td><b>{ total_count_person }</b></td>
												</tr>
											</tbody>
										</table>
									</fieldset>
								</div>
								<div className="column is-4">
									<fieldset className="fieldset">
										<legend>Sin Categoría</legend>
										<table className="inm-table">
											<thead>
											<tr>
												<th>Grupo etario</th>
												<th>Mujeres</th>
												<th>Hombres</th>
												<th>Otros</th>
											</tr>
											</thead>
											<tbody>
												<tr>
													<td>0 a 14</td>
													<td>{persons_total['count_person_f_1_1']}</td>
													<td>{persons_total['count_person_m_1_1']}</td>
													<td>{persons_total['count_person_o_1_1']}</td>
												</tr>
												<tr>
													<td>15 a 29</td>
													<td>{persons_total['count_person_f_1_2']}</td>
													<td>{persons_total['count_person_m_1_2']}</td>
													<td>{persons_total['count_person_o_1_2']}</td>
												</tr>
												<tr>
													<td>30 a 44</td>
													<td>{persons_total['count_person_f_1_3']}</td>
													<td>{persons_total['count_person_m_1_3']}</td>
													<td>{persons_total['count_person_o_1_3']}</td>
												</tr>
												<tr>
													<td>45 a 59</td>
													<td>{persons_total['count_person_f_1_4']}</td>
													<td>{persons_total['count_person_m_1_4']}</td>
													<td>{persons_total['count_person_o_1_4']}</td>
												</tr>
												<tr>
													<td>60 o más</td>
													<td>{persons_total['count_person_f_1_5']}</td>
													<td>{persons_total['count_person_m_1_5']}</td>
													<td>{persons_total['count_person_o_1_5']}</td>
												</tr>
											</tbody>
										</table>
									</fieldset>
								</div>
								<div className="column is-4">
									<fieldset className="fieldset">
										<legend>Indígenas</legend>
										<table className="inm-table">
											<thead>
											<tr>
												<th>Grupo etario</th>
												<th>Mujeres</th>
												<th>Hombres</th>
												<th>Otros</th>
											</tr>
											</thead>
											<tbody>
											<tr>
													<td>0 a 14</td>
													<td>{persons_total['count_person_f_2_1']}</td>
													<td>{persons_total['count_person_m_2_1']}</td>
													<td>{persons_total['count_person_o_2_1']}</td>
												</tr>
												<tr>
													<td>15 a 29</td>
													<td>{persons_total['count_person_f_2_2']}</td>
													<td>{persons_total['count_person_m_2_2']}</td>
													<td>{persons_total['count_person_o_2_2']}</td>
												</tr>
												<tr>
													<td>30 a 44</td>
													<td>{persons_total['count_person_f_2_3']}</td>
													<td>{persons_total['count_person_m_2_3']}</td>
													<td>{persons_total['count_person_o_2_3']}</td>
												</tr>
												<tr>
													<td>45 a 59</td>
													<td>{persons_total['count_person_f_2_4']}</td>
													<td>{persons_total['count_person_m_2_4']}</td>
													<td>{persons_total['count_person_o_2_4']}</td>
												</tr>
												<tr>
													<td>60 o más</td>
													<td>{persons_total['count_person_f_2_5']}</td>
													<td>{persons_total['count_person_m_2_5']}</td>
													<td>{persons_total['count_person_o_2_5']}</td>
												</tr>
											</tbody>
										</table>
									</fieldset>
								</div>
								<div className="column is-4">
									<fieldset className="fieldset">
										<legend>Con Discapacidad</legend>
										<table className="inm-table">
											<thead>
											<tr>
												<th>Grupo etario</th>
												<th>Mujeres</th>
												<th>Hombres</th>
												<th>Otros</th>
											</tr>
											</thead>
											<tbody>
											<tr>
													<td>0 a 14</td>
													<td>{persons_total['count_person_f_3_1']}</td>
													<td>{persons_total['count_person_m_3_1']}</td>
													<td>{persons_total['count_person_o_3_1']}</td>
												</tr>
												<tr>
													<td>15 a 29</td>
													<td>{persons_total['count_person_f_3_2']}</td>
													<td>{persons_total['count_person_m_3_2']}</td>
													<td>{persons_total['count_person_o_3_2']}</td>
												</tr>
												<tr>
													<td>30 a 44</td>
													<td>{persons_total['count_person_f_3_3']}</td>
													<td>{persons_total['count_person_m_3_3']}</td>
													<td>{persons_total['count_person_o_3_3']}</td>
												</tr>
												<tr>
													<td>45 a 59</td>
													<td>{persons_total['count_person_f_3_4']}</td>
													<td>{persons_total['count_person_m_3_4']}</td>
													<td>{persons_total['count_person_o_3_4']}</td>
												</tr>
												<tr>
													<td>60 o más</td>
													<td>{persons_total['count_person_f_3_5']}</td>
													<td>{persons_total['count_person_m_3_5']}</td>
													<td>{persons_total['count_person_o_3_5']}</td>
												</tr>
											</tbody>
										</table>
									</fieldset>
								</div>
								<div className="column is-4">
									<fieldset className="fieldset">
										<legend>Afrodescendientes</legend>
										<table className="inm-table">
											<thead>
											<tr>
												<th>Grupo etario</th>
												<th>Mujeres</th>
												<th>Hombres</th>
												<th>Otros</th>
											</tr>
											</thead>
											<tbody>
											<tr>
													<td>0 a 14</td>
													<td>{persons_total['count_person_f_4_1']}</td>
													<td>{persons_total['count_person_m_4_1']}</td>
													<td>{persons_total['count_person_o_4_1']}</td>
												</tr>
												<tr>
													<td>15 a 29</td>
													<td>{persons_total['count_person_f_4_2']}</td>
													<td>{persons_total['count_person_m_4_2']}</td>
													<td>{persons_total['count_person_o_4_2']}</td>
												</tr>
												<tr>
													<td>30 a 44</td>
													<td>{persons_total['count_person_f_4_3']}</td>
													<td>{persons_total['count_person_m_4_3']}</td>
													<td>{persons_total['count_person_o_4_3']}</td>
												</tr>
												<tr>
													<td>45 a 59</td>
													<td>{persons_total['count_person_f_4_4']}</td>
													<td>{persons_total['count_person_m_4_4']}</td>
													<td>{persons_total['count_person_o_4_4']}</td>
												</tr>
												<tr>
													<td>60 o más</td>
													<td>{persons_total['count_person_f_4_5']}</td>
													<td>{persons_total['count_person_m_4_5']}</td>
													<td>{persons_total['count_person_o_4_5']}</td>
												</tr>
											</tbody>
										</table>
									</fieldset>
								</div>
								<div className="column is-4">
									<fieldset className="fieldset">
										<legend>Migrantes</legend>
										<table className="inm-table">
											<thead>
											<tr>
												<th>Grupo etario</th>
												<th>Mujeres</th>
												<th>Hombres</th>
												<th>Otros</th>
											</tr>
											</thead>
											<tbody>
											<tr>
													<td>0 a 14</td>
													<td>{persons_total['count_person_f_5_1']}</td>
													<td>{persons_total['count_person_m_5_1']}</td>
													<td>{persons_total['count_person_o_5_1']}</td>
												</tr>
												<tr>
													<td>15 a 29</td>
													<td>{persons_total['count_person_f_5_2']}</td>
													<td>{persons_total['count_person_m_5_2']}</td>
													<td>{persons_total['count_person_o_5_2']}</td>
												</tr>
												<tr>
													<td>30 a 44</td>
													<td>{persons_total['count_person_f_5_3']}</td>
													<td>{persons_total['count_person_m_5_3']}</td>
													<td>{persons_total['count_person_o_5_3']}</td>
												</tr>
												<tr>
													<td>45 a 59</td>
													<td>{persons_total['count_person_f_5_4']}</td>
													<td>{persons_total['count_person_m_5_4']}</td>
													<td>{persons_total['count_person_o_5_4']}</td>
												</tr>
												<tr>
													<td>60 o más</td>
													<td>{persons_total['count_person_f_5_5']}</td>
													<td>{persons_total['count_person_m_5_5']}</td>
													<td>{persons_total['count_person_o_5_5']}</td>
												</tr>
											</tbody>
										</table>
									</fieldset>
								</div>
							</div>
							<br /><br />
							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button className="button is-info" type="button" onClick={this.props.closeModal}>Cerrar</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<button className="modal-close is-large" aria-label="close" onClick={this.props.closeModal}></button>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/elements/revision/reports_financial.jsx